export const FN_FINISHING_LINE = 'finishingLine';
